import React, { useEffect, useRef, useContext, useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';

import Router from 'router/index';
import { color } from 'styles/pallete';
import LoadGeneralContext from 'context/LoadGeneralContext';
import LoginContext from 'context/LoginContext';
import TypeStoreContext from 'context/TypeStoreContext';
import GeneralConfigContext from 'context/GeneralConfigContext';
import SystemNotifyContext from 'context/SystemNotifyContext';
import RolesUserContext from 'context/RolesUserContext';
import './i18n';
import {
	getObjOnLocalStorage,
	refreshToken,
	saveObjOnLocalStorage,
	logoutSystem,
	deleteEpecificObjOnLocalStorage,
	handleWithTypeStore,
	getRoles
} from 'utils/functions';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { localStoreUser } from 'i18n/consts';
import { resources } from 'i18n';
import { UserProps } from 'types/UserProps';
import { TokensResp } from 'types/TokensResp';
import { RespRefreshTokenProps } from 'types/RespRefreshTokenProps';
import { apiAxiosCMS } from 'services/api';

function App() {
	const hasRun = useRef(false);
	const { i18n, t }: UseTranslationProps = useTranslation();
	const { setIsOpenLoad, setColor, setMessage } =
		useContext(LoadGeneralContext);
	const { setTypeStore } = useContext(TypeStoreContext);
	const { setIsLogged } = useContext(LoginContext);
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setGeneralConfigs } = useContext(GeneralConfigContext);
	const { setListRoles, setIsSearchingRoles } = useContext(RolesUserContext);

	async function getGeneralConfig() {
		await apiAxiosCMS
			.get('general-config')
			.then((resp) => {
				if (typeof resp.data === 'object') {
					setGeneralConfigs(resp.data);
				}
			})
			.catch((error) => {
				handleNotify(
					error?.message || 'Erro ao buscar as configurações gerais',
					'error'
				);
			});
	}

	//responsável pelo i18
	useEffect(() => {
		const lg = getObjOnLocalStorage(localStoreUser);
		const languageDefaultBrowser = navigator.language.split(
			'-'
		)[0] as keyof typeof resources;

		if (lg === null || lg === undefined || lg === '') {
			i18n.changeLanguage(
				resources[languageDefaultBrowser] ? languageDefaultBrowser : 'en'
			);
			return;
		} else {
			i18n.changeLanguage(lg?.language || 'pt');
		}
	}, [i18n]);

	//executado apenas 1 vez quando o CMS é montado para verificar se o token é válido
	useEffect(() => {
		(async () => {
			//if para garantir q esse código só vair rodar 1 vez
			if (hasRun.current) return; // Se já rodou, sai da função
			hasRun.current = true; // Marca que já rodou

			const dataUser: null | UserProps = getObjOnLocalStorage();
			const tokens: null | TokensResp = getObjOnLocalStorage('tokensMondelez');

			if (dataUser !== null && tokens !== null) {
				setColor(color.interface.white);
				setMessage(t('tokenValidate'));

				const resp: RespRefreshTokenProps = await refreshToken(
					dataUser.id,
					tokens,
					setIsOpenLoad,
					setColor,
					setMessage,
					t
				);

				if (resp.isSuccess && resp.tokens !== null) {
					setIsLogged(true);
					saveObjOnLocalStorage({ ...resp.tokens }, 'tokensMondelez');
				} else {
					logoutSystem();
					setIsLogged(false);
				}
			} else {
				deleteEpecificObjOnLocalStorage('tokensMondelez');
				deleteEpecificObjOnLocalStorage('userDataMondelez');
			}
		})();
	}, []);

	//requisições de configs iniciais
	useEffect(() => {
		(async () => {
			setIsOpenLoad(true);

			//getRoles - busca as roles que são os tipos de usuários no sistema
			//getGeneralConfig- busca no back quais páginas dinamicas não são editáveis pelo usuário
			await Promise.all([
				getRoles(setIsSearchingRoles, setListRoles, handleNotify),
				getGeneralConfig()
			]);

			setIsOpenLoad(false);
		})();
	}, []);

	//altera o tipo da loja baseado no nome da loja que está na url
	useLayoutEffect(() => {
		handleWithTypeStore(setTypeStore);
	}, []);

	return (
		<div>
			<Router />
		</div>
	);
}

export default App;
